




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnFormTitle } from '@/components';
import { AcgnStatisticCard, AcgnStatisticChart, AcgnStatisticStaffChartd } from './components';

// 项目统计
@Component({
  components: {
    AcgnFormTitle,
    AcgnStatisticCard,
    AcgnStatisticChart,
    AcgnStatisticStaffChartd
  }
})
export default class AcgnStatistic extends Vue {
  public name: string = 'AcgnStatistic';

  @Prop({ default: null }) public comicId: number | null; // 项目id

  // 1：管理方-总览 2：管理方-项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  @Prop({ default: true }) public isShowTitle: boolean; // 是否显示标题

  @Prop({ default: false }) public isShowTarget: boolean; // 是否显示目标进度
}
